import React, { useState, useEffect, useRef } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";

const colors = ["pink", "#800000"];

export default function DashboardChart({ earnings = [] }) {
  const chartContainerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  // Mapping earnings data to months
  const dataset = [
    { month: "January", total: 0 },
    { month: "February", total: 0 },
    { month: "March", total: 0 },
    { month: "April", total: 0 },
    { month: "May", total: 0 },
    { month: "June", total: 0 },
    { month: "July", total: 0 },
    { month: "August", total: 0 },
    { month: "September", total: 0 },
    { month: "October", total: 0 },
    { month: "November", total: 0 },
    { month: "December", total: 0 },
  ];

  earnings.forEach((earning) => {
    const monthIndex = dataset.findIndex(
      (data) => data.month === earning.month
    );
    if (monthIndex !== -1) {
      dataset[monthIndex].total = earning.totalEarnings; // Set earnings for the respective month
    }
  });

  // Filter out months where total earnings are 0
  const filteredDataset = dataset.filter((data) => data.total > 0);

  const valueFormatter = (value) => `${value} CA$`;

  useEffect(() => {
    const updateDimensions = () => {
      if (chartContainerRef.current) {
        const { width } = chartContainerRef.current.getBoundingClientRect();
        const calculatedHeight = Math.max(width / 2.5, 300);
        setDimensions({ width, height: calculatedHeight });
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div
      ref={chartContainerRef}
      style={{ width: "auto", height: "auto", overflow: "hidden" }}
    >
      <BarChart
        dataset={filteredDataset}
        xAxis={[{ scaleType: "band", dataKey: "month" }]}
        series={[
          {
            dataKey: "total",
            valueFormatter,
            color: colors,
          },
        ]}
        width={dimensions.width}
        height={dimensions.height}
        sx={{
          [`.${axisClasses.left} .${axisClasses.label}`]: {
            transform: "translate(-20px, 0)",
          },
        }}
      />
    </div>
  );
}
